module.exports = __webpack_public_path__ + "ee2c01e251eef5f54a83b047bb5362ba.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/boots-peg-leg-s.png
// module id = 1885
// module chunks = 0